import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "chart-values" }
const _hoisted_2 = ["id", "value", "label", "min", "max", "disabled", "onTextInputChange"]
const _hoisted_3 = ["id", "checked", "disabled", "onCheckboxChange"]
const _hoisted_4 = ["id", "value", "label", "options", "disabled", "onDropdownChange"]
const _hoisted_5 = ["id", "value", "label", "disabled", "onTextInputChange"]

import { watch, computed } from 'vue';
import { ChartSetting } from '../../models/catalogservice/ui-types';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartValues',
  props: {
    chart: {},
    value: {},
    title: {},
    mode: {},
    disabled: { type: Boolean }
  },
  emits: ['valid'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emit function
const emit = __emit;

const valid = computed(() => {
  return props.chart.every((setting) => {
    if (setting.type !== 'number' && setting.type !== 'integer') {
      return true;
    }

    const rawValue = props.value[setting.name];

    if (rawValue === undefined || rawValue === null || rawValue === '') {
      return true;
    }

    const value = Number(rawValue);

    if (Number.isNaN(value)) {
      return false;
    }

    if ((setting.minimum != null && setting.minimum !== undefined) && value < Number(setting.minimum)) {
      return false;
    }

    if ((setting.maximum != null && setting.maximum !== undefined) && value > Number(setting.maximum)) {
      return false;
    }

    return true;
  });
})

watch(valid, (isValid) => {
  emit("valid", isValid);
}, { immediate: true });

const onInputCheckbox = (key: string, value: boolean) => {
  props.value[key] = value ? 'true' : 'false';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.chart, (setting) => {
      return (_openBlock(), _createElementBlock("div", {
        key: setting.name,
        class: "chart-values-item"
      }, [
        (setting.type === 'number' || setting.type === 'integer')
          ? (_openBlock(), _createElementBlock("trailhand-text-input", {
              key: 0,
              id: setting.name,
              style: {"flex":"1"},
              value: props.value[setting.name],
              label: setting.name,
              type: "number",
              min: setting.minimum,
              max: setting.maximum,
              disabled: props.disabled,
              onTextInputChange: (e) => props.value[setting.name] = e.detail.value
            }, null, 40, _hoisted_2))
          : (setting.type === 'bool')
            ? (_openBlock(), _createElementBlock("trailhand-checkbox", {
                key: 1,
                id: setting.name,
                checked: props.value[setting.name] === 'true',
                disabled: props.disabled,
                onCheckboxChange: (e) => onInputCheckbox(setting.name, e.detail.checked)
              }, _toDisplayString(setting.name), 41, _hoisted_3))
            : (setting.type === 'string' && setting.enum)
              ? (_openBlock(), _createElementBlock("trailhand-dropdown", {
                  key: 2,
                  id: setting.name,
                  style: {"flex":"1"},
                  value: props.value[setting.name],
                  label: setting.name,
                  options: setting.enum.map((option) => ({ label: option, value: option })),
                  disabled: props.disabled,
                  onDropdownChange: (e) => props.value[setting.name] = e.detail.value
                }, null, 40, _hoisted_4))
              : (setting.type === 'string')
                ? (_openBlock(), _createElementBlock("trailhand-text-input", {
                    key: 3,
                    id: setting.name,
                    style: {"flex":"1"},
                    value: props.value[setting.name],
                    label: setting.name,
                    disabled: props.disabled,
                    onTextInputChange: (e) => props.value[setting.name] = e.detail.value
                  }, null, 40, _hoisted_5))
                : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})